export var PlayerJumpShipTimingType;
(function (PlayerJumpShipTimingType) {
    PlayerJumpShipTimingType["NOW"] = "now";
    PlayerJumpShipTimingType["END_OF_MONTH"] = "endOfMonth";
})(PlayerJumpShipTimingType || (PlayerJumpShipTimingType = {}));
//# sourceMappingURL=PlayerJumpShipTimingType.js.map